import { SubmissionError } from 'redux-form';
import fetch from '../../utils/fetch';
import { success as createSuccess } from './create';

export function retrieveError(retrieveError) {
  return {type: 'CLIENTPRODUCT_UPDATE_RETRIEVE_ERROR', retrieveError};
}

export function retrieveLoading(retrieveLoading) {
  return {type: 'CLIENTPRODUCT_UPDATE_RETRIEVE_LOADING', retrieveLoading};
}

export function retrieveSuccess(retrieved) {
  return {type: 'CLIENTPRODUCT_UPDATE_RETRIEVE_SUCCESS', retrieved};
}

export function retrieve(id) {
  return (dispatch) => {
    dispatch(retrieveLoading(true));

    return fetch(id)
      .then(response => response.json())
      .then(data => {
        dispatch(retrieveLoading(false));
        dispatch(retrieveSuccess(data));
      })
      .catch(e => {
        dispatch(retrieveLoading(false));
        dispatch(retrieveError(e.message));
      });
  };
}

export function updateError(updateError) {
  return {type: 'CLIENTPRODUCT_UPDATE_UPDATE_ERROR', updateError};
}

export function updateLoading(updateLoading) {
  return {type: 'CLIENTPRODUCT_UPDATE_UPDATE_LOADING', updateLoading};
}

export function updateSuccess(updated) {
  return {type: 'CLIENTPRODUCT_UPDATE_UPDATE_SUCCESS', updated};
}

export function update(item, values) {
  return (dispatch) => {
    dispatch(updateError(null));
    dispatch(createSuccess(null));
    dispatch(updateLoading(true));

    // console.log("JS", values);
    
    let normalizedValues = { ...values } ;
    var styleObject = {}
    let css = generateCssString(values);
    delete normalizedValues.product;
    if (normalizedValues.clientProductStyles && normalizedValues.clientProductStyles.length) {
      // console.log("updating client product styles..");
      styleObject =     {
        ...normalizedValues.clientProductStyles[0],
        'styleValue': css
      };

      //christos notes: in client product styles update send id instead of @id as object key
      styleObject['id'] = styleObject['@id'];
      delete styleObject['@id'];
      
    }
    else{
      // console.log("inserting client product styles..");
      styleObject =     {
        'styleValue': css
      };
    }

    //get client product options from form values and construct the object to send in server 
    let productOptionFields = {};
    Object.keys(normalizedValues).forEach( k => {
      if (k.indexOf('/api/product_options/') !== -1){
        productOptionFields[k] = normalizedValues[k];
      }
    });

    let normalizedClientProductOptions = [];
    
    //update product options if already exist
    normalizedValues.clientProductOptions.forEach( v => {
      if (productOptionFields.hasOwnProperty(v.productOption['@id'])){
        let objToPush = {};
        // objToPush['@id'] = v['@id'];
        // christos note: on client product update send key id instead of @id 
        objToPush['id'] = v['@id'];
        objToPush['productOption'] =  v.productOption['@id'];
        objToPush['optionValue'] =  String(productOptionFields[v.productOption['@id']]);
        normalizedClientProductOptions.push(objToPush);

        delete productOptionFields[v.productOption['@id']];
      }
    });

    //insert new product options 
    Object.keys(productOptionFields).forEach( k => {
        normalizedClientProductOptions.push({
        'productOption': k,
        'optionValue': String(productOptionFields[k])
      });
    });

    //remove false values from clientproductoptions array 
    let tmpNormalizer = [];
    normalizedClientProductOptions.forEach( (v, key) => {
      if (v.optionValue && v.optionValue !== 'false' && v.optionValue !== false) {
        tmpNormalizer.push(v);
      }
    });
    normalizedClientProductOptions = tmpNormalizer;

    delete normalizedValues.clientProductOptions;
    //if no values are set send default
    normalizedValues = {
      ...normalizedValues,
      clientProductStyles: [
        styleObject
      ],
      clientProductOptions: normalizedClientProductOptions
    }


    return fetch(item['@id'], {
        method: 'PUT',
        headers: new Headers({'Content-Type': 'application/ld+json'}),
        body: JSON.stringify(normalizedValues),
      }
    )
      .then(response => response.json())
      .then(data => {
        dispatch(updateLoading(false));
        dispatch(updateSuccess(data));
      })
      .catch(e => {
        dispatch(updateLoading(false));

        if (e instanceof SubmissionError) {
          dispatch(updateError(e.errors._error));
          throw e;
        }

        dispatch(updateError(e.message));
      });
  };
}

export function reset() {
  return {type: 'CLIENTPRODUCT_UPDATE_RESET'};
}







/*****************************************************************
 * this function generates the final css to be submited on server, 
 * @param values: is the redux form values object
 * @return returns a string with css rules
 **************************************************************/
export function generateCssString(values) {
  //extract css related fields from our form values
  let styleKeys = Object.keys(values).filter(v=>{
    return /style#/.test(v);
  });

  let cssString = ''; 
  styleKeys.forEach(s=>{
    let cssProperty = s.match(/#(.*)#/)[1];
    let cssClass = s.match(/@(.*)@/)[1];
    let cssValue = values[s];
    let cssRule = `.${cssClass} {${cssProperty}: ${cssValue}!important}`;
    cssString = cssString.concat(cssRule);
  });
  // console.log(cssString);
  return cssString;
}


/*****************************************************************
 * this function decodes the css text to an array of key values to be used in our forms
 * @param cssString: the css string e.g: .bluegray-bg{backround-color: red}.darkblue-bg{font-size: 12px} to [{style#cssProperty#@cssClass@: css Value}]
 **************************************************************/
export function decodeCssString (cssString) {
  let decodedValues = [];
  let decodedRules = cssString.split(/([.](?!\d))/).filter((f, i) => i % 2 === 0 && i > 0 );
  decodedRules.forEach(r=>{
  if (r.length) {
    // console.log(r);
    let cssClass = r.split(' ')[0];
    let cssProperty = r.match(/{(.*):/)[1];
    let cssValue = r.match(/:\s(.*)!/)[1];
    let fieldName = `style#${cssProperty}#@${cssClass}@`;
    let objectToPush = {};
    objectToPush[fieldName] = cssValue;
    decodedValues.push(objectToPush);
  }
 });
  return decodedValues;
}


// WEBPACK FOOTER //
// ./src/actions/clientproduct/update.js